import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {HttpStatusCodes, timePhaseTypes} from '../../util/uiconstants';

export default function auditphaseMilestoneDetailsReducer(state = initialstate.auditphaseMilestoneDetails, action) {
	switch (action.type) {
		case types.GET_AUDITPHASE_MILESTONE_DETAILS: {
			if (action.response && action.response.items && action.response.items.length > 0) {
				let newState = _.cloneDeep(action.response);
				if (action.filterAuditPhaseMilestone) {
					newState['items'] = _.filter(newState.items, (item) => {
						return item.taskOpenCount + item.taskInProgressCount + item.taskInReviewCount + item.taskCompleteCount > 0;
					});
				}
				newState['auditPhaseId'] = action.response && action.response.defaultTab;
				return newState;
			}
			return state;
		}
		case types.UPDATE_MILESTONE_DATA: {
			return Object.assign({}, state, action.data);
		}
		case types.ADD_TIMEPHASE: {
			if (action.response) {
				let newState = _.cloneDeep(state);
				if (newState != null && newState.items != null) {
					let items = [];
					let dOrder = 1;
					let newTimePhase = getAddedTimePhaseItem(action.response, newState.items.length + 1);
					newState.items.push(newTimePhase);

					let redundantOrderVals = timePhaseTypes.filter((tpt) => tpt.isactive === 0).map((tpt) => tpt.uidisplayorder);
					redundantOrderVals.forEach((orderval) => {
						let filterCustomTimephaseTypes = timePhaseTypes
							.filter((tpt) => tpt.uidisplayorder === orderval)
							.map((tpt) => tpt.value);
						let filterCustomTimephases = newState.items.filter((tp) =>
							filterCustomTimephaseTypes.includes(tp.timephaseTypeId)
						);
						let sortedCustomTimephases = filterCustomTimephases.sort((a, b) =>
							a.timephaseName.localeCompare(b.timephaseName)
						);
						sortedCustomTimephases.forEach((t) => {
							t.uiDisplayOrder = dOrder;
							dOrder += 1;
						});
						items = [...items, ...sortedCustomTimephases];
					});

					let filterTimephaseTypes = timePhaseTypes.filter((tpt) => tpt.uidisplayorder >= 3);
					let orderedTimePhaseTypes = _.sortBy(filterTimephaseTypes, 'uidisplayorder').map((tpt) => tpt.value);
					orderedTimePhaseTypes.forEach((timephasetypeid) => {
						let filteredTimePhases = newState.items.filter((tp) => tp.timephaseTypeId == timephasetypeid);
						if (filteredTimePhases.length > 0) {
							let sortedTimePhases = filteredTimePhases.sort((a, b) => a.timephaseName.localeCompare(b.timephaseName));
							sortedTimePhases.forEach((t) => {
								t.uiDisplayOrder = dOrder;
								dOrder += 1;
							});
							items = [...items, ...sortedTimePhases];
						}
					});
					return {...newState, items};
				} else {
					let items = [];
					let newTimePhase = getAddedTimePhaseItem(action.response, 1);
					items.push(newTimePhase);
					return {...newState, items};
				}
			}

			return state;
		}
		case types.EDIT_TIMEPHASE: {
			if (action.response) {
				let newState = _.cloneDeep(state);
				let items = [];
				let displayOrder = 1;
				let indexToUpdate = newState.items.findIndex((i) => i.timephaseId == action.response.id);
				newState.items[indexToUpdate].timephaseName = action.response.periodName;
				newState.items[indexToUpdate].name = action.response.periodName;
				newState.items[indexToUpdate].timephaseTypeId = action.response.timePhaseTypeId;
				newState.items[indexToUpdate].startDate = action.response.startDate;
				newState.items[indexToUpdate].endDate = action.response.dueDate;
				newState.items[indexToUpdate].isKeyEvent = action.response.isKeyEvent;

				let redundantOrderVals = timePhaseTypes.filter((tpt) => tpt.isactive === 0).map((tpt) => tpt.uidisplayorder);
				redundantOrderVals.forEach((orderval) => {
					let filterCustomTimephaseTypes = timePhaseTypes
						.filter((tpt) => tpt.uidisplayorder === orderval)
						.map((tpt) => tpt.value);
					let filterCustomTimephases = newState.items.filter((tp) =>
						filterCustomTimephaseTypes.includes(tp.timephaseTypeId)
					);
					let sortedCustomTimephases = filterCustomTimephases.sort((a, b) =>
						a.timephaseName.localeCompare(b.timephaseName)
					);
					sortedCustomTimephases.forEach((t) => {
						t.uiDisplayOrder = displayOrder;
						displayOrder += 1;
					});
					items = [...items, ...sortedCustomTimephases];
				});

				let filterTimephaseTypes = timePhaseTypes.filter((tpt) => tpt.uidisplayorder >= 3);
				let orderedTimePhaseTypes = _.sortBy(filterTimephaseTypes, 'uidisplayorder').map((tpt) => tpt.value);
				orderedTimePhaseTypes.forEach((timephasetypeid) => {
					let filteredTimePhases = newState.items.filter((tp) => tp.timephaseTypeId == timephasetypeid);
					if (filteredTimePhases.length > 0) {
						let sortedTimePhases = filteredTimePhases.sort((a, b) => a.timephaseName.localeCompare(b.timephaseName));
						sortedTimePhases.forEach((t) => {
							t.uiDisplayOrder = displayOrder;
							displayOrder += 1;
						});
						items = [...items, ...sortedTimePhases];
					}
				});
				return {...newState, items};
			}

			return state;
		}

		case types.DELETE_TIMEPHASE: {
			if (action.timephase) {
				// get data
				let newState = _.cloneDeep(state);
				let displayOrder = 1;
				newState.items = newState.items.filter((i) => i.timephaseId !== action.timephase.timephaseId);
				newState.items.forEach((t) => {
					t.uiDisplayOrder = displayOrder;
					displayOrder += 1;
				});
				return newState;
			}
			return state;
		}

		default:
			return state;
	}
}

function getAddedTimePhaseItem(res, displayorder) {
	let auditphasetypeid = res.timePhaseTypeId == 9 ? 3 : res.timePhaseTypeId > 11 && res.timePhaseTypeId < 17 ? 1 : 2;
	return {
		auditPhaseId: auditphasetypeid,
		endDate: res.dueDate,
		engagementID: res.engagementId,
		isKeyEvent: res.isKeyEvent,
		isOverdue: false,
		name: res.periodName,
		prepAssignmentCompleteCount: 0,
		prepAssignmentInprogressCount: 0,
		prepAssignmentOpenCount: 0,
		reviewAssignmentCompleteCount: 0,
		reviewAssignmentInprogressCount: 0,
		reviewAssignmentOpenCount: 0,
		startDate: res.startDate,
		taskCompleteCount: 0,
		taskInProgressCount: 0,
		taskInReviewCount: 0,
		taskOpenCount: 0,
		timePhaseCommentOpenCount: 0,
		timePhaseDocumentAnnotationOpenCount: 0,
		timePhaseTaskAnnotationOpenCount: 0,
		timePhaseTypeCommentOpenCount: null,
		timePhaseTypeDocumentAnnotationOpenCount: null,
		timePhaseTypeTaskAnnotationOpenCount: 0,
		timephaseAnnotationCount: 0,
		timephaseTypeAnnotationCount: null,
		timephaseId: res.id,
		timephaseName: res.periodName,
		timephaseTypeId: res.timePhaseTypeId,
		uiDisplayOrder: displayorder
	};
}
